import { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import styled from 'styled-components'

import { trackUserSignedOut } from '../../Global/Analytics'

const StyledModalAlertText = styled.div`
  width: 0;
  height: 0;
  clip: rect(0, 0, 0, 0);
  position: absolute;
`

const TimeoutModal = ({
  showModal,
  handleClose,
  handleLogout,
  timeoutInSeconds,
}) => {
  const [timeElapsed, setTimeElapsed] = useState(0)
  const [modalStatus, setModalStatus] = useState('')

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeElapsed((prevTime) => prevTime + 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const onClose = (e) => {
    setModalStatus('close modal button click')
    setTimeout(() => {
      handleClose(e)
    }, 1000)
  }

  const handleStayClick = (e) => {
    setModalStatus('stay signed in click')
    setTimeout(() => {
      handleClose(e)
    }, 1000)
  }

  const handleSignOutClick = (e) => {
    setModalStatus('sign out click')
    setTimeout(() => {
      trackUserSignedOut()
      handleLogout()
    }, 1000)
  }

  if (timeElapsed >= timeoutInSeconds) handleLogout()
  return (
    <Modal show={showModal} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>You Have Been Idle!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span role="timer" aria-live="off">
          Your session will expire in {timeoutInSeconds - timeElapsed}{' '}
          seconds. What would you like to do?
        </span>
        {(timeoutInSeconds - timeElapsed) % 20 === 0 ? (
          <StyledModalAlertText
            id="alert"
            role="alert"
            aria-live="assertive"
          >
            Your session will expire in{' '}
            {timeoutInSeconds - timeElapsed} seconds. What would you
            like to do?
          </StyledModalAlertText>
        ) : (
          ''
        )}
        {modalStatus !== '' && (
          <p role="alert" aria-live="assertive" className="sr-only">
            {modalStatus}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={handleSignOutClick}
          uid="time_out"
        >
          Sign out
        </Button>
        <Button
          variant="primary"
          onClick={handleStayClick}
          uid="time_out"
        >
          Stay signed in
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default TimeoutModal
